import React, { useContext, useEffect, useState } from 'react'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { FormCabinetContext, OwnerType, SexType } from '../types'
import { SelectElement } from '../../../HtmlComponents/SelectElement'
import { InputImage } from '../../../HtmlComponents/InputImage'
import { hostName } from '../../../requestMethods'
import { useSelector } from 'react-redux'
import { State } from '../../../redux/store'
import { DoctorInterface } from '../../doctors/types'
import ReactSelect from 'react-select'
import { InputRadio } from '../../../HtmlComponents/InputRadio'
import { useLocation } from 'react-router'
import { moughataaInterface } from '../../moughataa/types'

const InputsCabinet = () => {

  const {
    name, setName, phone, setPhone, address, setAddress, logo, setLogo, authorization, setAuthorization, type, setType, 
    moughataa, setMoughataa,
    chooseDoctor, setChooseDoctor, existedDoctor, setExistedDoctor, 
     
    fullName, setFullName, yearOfBirth, setYearOfBirth, placeOfBirth, setPlaceOfBirth,
    sex, setSex, telephone, setTelephone, whatsapp, setWhatsapp, email, setEmail, current, setCurrent, medecinType, setMedecinType,
    origin, setOrigin, inscriptionDate, setInscriptionDate, avatar, setAvatar, password, setPassword,
    speciality, setSpeciality
  } = useContext(FormCabinetContext)

  const { doctors } = useSelector((state: State) => state.doctors)
  const { moughataas } = useSelector((state: State) => state.moughataas)

  const [optionsDoctor, setOptionsDoctor] = useState<any[]>([])
  const [optionsMoughataas, setOptionsMoughataas] = useState<any[]>([])


  useEffect(() => {
    setOptionsDoctor(doctors.map((doctor: DoctorInterface) => ({ value: doctor._id, label: doctor.fullName  })))
    // setOptionsDoctor([{ value: "", label: "Choisir un docteur"  }, ...doctors.map((doctor: DoctorInterface) => ({ value: doctor._id, label: doctor.fullName  }))])
  }, [doctors])

  useEffect(() => {
    setOptionsMoughataas(moughataas.map((mough: moughataaInterface) => ({ value: mough._id, label: mough.name  })))
  }, [moughataas])


  useEffect(() => {
    setChooseDoctor(optionsDoctor[0])
  }, [optionsDoctor, setChooseDoctor])

  const location = useLocation()

  useEffect(() => {
    location.pathname.split("/")[2] === "update" && setExistedDoctor(false)
  }, [location, setExistedDoctor])

  const { medecinTypes } = useSelector((state: State) => state.medecinType)

  const [MedecineTypeArr, setMedecineTypeArr] = useState<any[]>([])

  useEffect(() => {
    setMedecineTypeArr(medecinTypes.map((docType: any) => ({ _id: docType._id, name: docType.title })))
  }, [medecinTypes])

  return (<>
    <section className=' bg-white p-3 pb-5 rounded shadow-lg'>
        <h3 className='text-lg font-bold mb-2 text-center'>Information du clinique</h3>
        <div className="grid md:grid-cols-2 gap-2">
          <InputElement name="Nom" placeholder='Nom du clinique' value={name} setValue={setName} />
          <InputElement name="Telephone" placeholder='Telephone du clinique' value={phone} setValue={setPhone} />
          <InputElement name="Addresse" placeholder='Addresse du clinique' value={address} setValue={setAddress} />
          {/* <SelectElement name="Choisir un moughataa" options={moughataas} defaultOption={<option>moughataa</option>} value={moughataa} setValue={setMoughataa} /> */}
          <div>
            <label className='font-bold text-gray-700' htmlFor="Moughataa">Moughataa</label>
            <ReactSelect id="Moughataa" onChange={(e) => setMoughataa(e)} value={moughataa} placeholder="moughataa" options={optionsMoughataas} /> 
          </div>

          <SelectElement name="type du propriétaire" options={OwnerType} defaultOption={<option>Choisir un type</option>} value={type} setValue={setType} />
          <InputElement name="Autorisation" placeholder='Autorisation du clinique' value={authorization} setValue={setAuthorization} />
          {
            // location.pathname.split("/")[2] === "create" &&
            <div className='grid md:grid-cols-2 col-span-2 mb-2'>
              <div>
                <p className='font-bold'>Le docteur deja existe ?</p>
                <InputRadio 
                  checked={existedDoctor === true && true} 
                  labelName="Oui"
                  id="Oui" 
                  booleanValue={true}
                  boolean={true} 
                  setValue={setExistedDoctor} 
                />
                <InputRadio 
                  checked={existedDoctor === false && true} 
                  labelName="Non"
                  id="Non" 
                  booleanValue={false}
                  boolean={true} 
                  setValue={setExistedDoctor} 
                />
              </div>
              {existedDoctor === true && <div>
                <label className='font-bold text-gray-700' htmlFor="cabinet">Choisir un doctor</label>
                <ReactSelect id="doctor" onChange={(e) => setChooseDoctor(e)} value={chooseDoctor} placeholder="Doctors" options={optionsDoctor}/> 
              </div>
              }
            </div>
          }

          <InputImage name="Logo" setValue={setLogo} />
          {(logo && (typeof logo === 'string')) && <img className='w-full h-56 col-span-2' src={hostName + "imgs/cabinets/" + logo} alt="logo" /> }          
          {(logo && (typeof logo !== 'string')) && <img className='w-full h-56 col-span-2' src={URL.createObjectURL(logo)} alt="logo" /> }          
          {/* {logo && <img style={{ width: "100px", height: "100px" }} src={URL.createObjectURL(logo)} alt="logo" />} */}
        </div>
    </section>
    {existedDoctor === false && 
      <section className=' bg-white p-3 pb-5 rounded shadow-lg'>
        <h3 className='text-lg font-bold col-span-2 mb-2 text-center'>information du proprietaire</h3>
        <div className="grid md:grid-cols-2 gap-2">
          <InputElement name="Nom Complet" placeholder='Nom Complet' value={fullName} setValue={setFullName} />
          <InputElement type="password" name="Mot de passe" placeholder='Mot de passe' value={password} setValue={setPassword} />
          <InputElement name="Annee de naissance" placeholder='Annee de naissance' value={yearOfBirth} setValue={setYearOfBirth} />
          <InputElement name="Lieu de naissance" placeholder='Lieu de naissance' value={placeOfBirth} setValue={setPlaceOfBirth} />
          <SelectElement name="Genre" options={SexType} defaultOption={<option>Choisir un genre</option>} value={sex} setValue={setSex} />
          <InputElement name="Telephone" placeholder='Telephone' value={telephone} setValue={setTelephone} />
          <InputElement name="Whatsapp" placeholder='Whatsapp' value={whatsapp} setValue={setWhatsapp} />
          <InputElement type="email" name="Email" placeholder='Email' value={email} setValue={setEmail} />
          <div>
            <p className='font-bold text-main'>Nationnalité</p>
            <InputElement name="Actuelle" placeholder='Actuelle' value={current} setValue={setCurrent} />
            <InputElement name="Origine" placeholder='Origine' value={origin} setValue={setOrigin} />  
            <SelectElement name="Medecin" options={MedecineTypeArr} defaultOption={<option>Choisir type</option>} value={medecinType} setValue={setMedecinType} />
          </div>
          
          <InputElement name="Specialité" placeholder='Specialité' value={speciality} setValue={setSpeciality} />
          <InputElement type="date" name="Date D'inscription" placeholder="Date D'inscription" value={inscriptionDate} setValue={setInscriptionDate} />
          <InputImage name="Profile" setValue={setAvatar} />
          {/* image comes from db */}
          {(avatar && (typeof avatar === 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
            <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={hostName + "imgs/doctors/" + avatar} alt="avatar" /> 
          </div>}
          {/* image choosen from here */}
          {(avatar && (typeof avatar !== 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
            <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={URL.createObjectURL(avatar)} alt="avatar" /> 
          </div>}
          {/* {avatar && <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px", justifySelf: "end" }} src={URL.createObjectURL(avatar)} alt="avatar"/>} */}
        </div>
      </section>
    }
  </>)
}

export default InputsCabinet